module.exports = __webpack_public_path__ + "img/对比.29640680.png";